







import {Component, Prop} from "vue-property-decorator"
import BaseVue from "@/utils/BaseVue"
import ProductListSelector from "@/components/ProductListSelector.vue"

@Component({components: {ProductListSelector}})
export default class ProductEditor extends BaseVue {
    @Prop() private storeId!: string
    @Prop() private productListId!: string
}
